import React, { Component } from 'react';
import './_chat.css';
import moment from 'moment';
import 'moment/locale/pt-br';

import { Lista } from '../lista';
import { withInfiniteScroll, withLoading, defaultLoadingCondition } from '../hocs';
import { compose } from 'lodash/fp';

const avatarEmpty = require('../../img/icons/people-white.png');

class ChatView extends Component {

    constructor(props) {
        super(props);
        this.user = JSON.parse(window.localStorage.getItem('userData'));
    }

    oldInnerScrollClientHeight = 0;

    needFixContainerScrollTop = () => this.innerScrollRef && this.innerScrollRef.clientHeight !== this.oldInnerScrollClientHeight;

    fixContainerScrollTop = () => {
        this.containerRef.scrollTop += this.innerScrollRef.clientHeight - this.oldInnerScrollClientHeight;
        this.oldInnerScrollClientHeight = this.innerScrollRef.clientHeight;
    }

    scrollToBottom = element => element.scrollTop = element.scrollHeight;

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { chats, event } = this.props;

        const chatsLength = chats.length;

        if (chatsLength > 0 && event === 'message-add' && prevProps.chats.length !== chatsLength) {
            this.scrollToBottom(this.containerRef);
        }
        if (this.needFixContainerScrollTop()) {
            this.fixContainerScrollTop();
        }
    }

    setRef = refName => element => this[refName] = element;

    static formatChatMsg = (message) => {

        if (!message) return;
        //const [_meta] = Object.values(metaMsg);
        // if(meta.userId == user)
        //     meta.isSender = true;
        // else
        //     meta.isSender = false;
        //console.log('META', moment(new Date(timestamp)).format('DD/MM/YYYY') )
        message.isSender = message.type == "system" ? true : false;
        //message.timestamp = new Date(message.timestamp).toLocaleDateString('pt-BR');
        message.timestamp = moment(new Date(Number.parseInt(message.timestamp))).fromNow();

        return message;
    }

    render() {
        const { chats, renderChats, selectedChat, loadMoreMessages, isLoadingMore } = this.props;

        const label = selectedChat ? "Digite uma mensagem" : "Selecione uma conversa";

        return (
            <div className="chat-container">
                <section className="section-chat" id="sectionChat" ref={this.setRef('containerRef')}>
                    {
                        chats.length > 0 && selectedChat ?
                            <AdvancedList
                                isLoading={isLoadingMore}
                                top
                                listRef={this.setRef('innerScrollRef')}
                                containerRef={this.containerRef}
                                innerScrollRef={this.innerScrollRef}
                                onPaginatedFetch={loadMoreMessages}
                                data={chats}
                                renderItem={renderChats} />
                            :
                            <div className="chat-empty">
                                <img src={avatarEmpty} />
                                <h2>{label}</h2>
                            </div>
                    }
                </section>
                {selectedChat ? this.props.children : null}
            </div>
        )
    }
}

ChatView.defaultProps = {
    children: null,
    renderChats: () => { },
    chats: []
}

const infiniteScrollCondition = ({ data = [], containerRef }) => {
    const result = (containerRef.scrollTop === 0)
        && data.length;
    return result;
}

const AdvancedList = compose(
    withInfiniteScroll(infiniteScrollCondition),
    withLoading(defaultLoadingCondition)
)(Lista);

// const AdvancedList = withInfiniteScroll(infiniteScrollCondition)(Lista);

export default ChatView;


// WEBPACK FOOTER //
// ./src/components/chatview/ChatView.js